import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuthentication } from './auth-provider';
import { validateRedirect } from './auth-utils';
import { confirmMfaCode, requestMfaCode, resendMfaCode } from './mfa-client';

const useMfaSetup = ({ redirect, redirectWhitelist }: { redirect?: string; redirectWhitelist: string[] }) => {
  const { apiUrl } = useAuthentication();
  const navigate = useNavigate();
  const [showCode, setShowCode] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState<string | null>(null);
  const [codeStepVisited, setCodeStepVisited] = useState(false);

  const handlePhoneSubmit = async (inputPhone: string) => {
    await requestMfaCode(apiUrl, inputPhone);
    setPhoneNumber(inputPhone);
    setShowCode(true);
  };

  const handleCodeSubmit = async (code: string) => {
    try {
      await confirmMfaCode(apiUrl, code);
      navigate(validateRedirect(redirect, redirectWhitelist) ?? '/', { replace: true });
    } catch {
      throw new Error('mfa verification failed');
    }
  };

  const handleResend = async () => {
    await resendMfaCode(apiUrl);
  };

  const handleChangeNumber = () => {
    setCodeStepVisited(true);
    setShowCode(false);
  };

  return {
    handleChangeNumber,
    handleCodeSubmit,
    handlePhoneSubmit,
    handleResend,
    navigateToCode: codeStepVisited ? () => setShowCode(true) : undefined,
    phoneNumber,
    showCode,
  };
};

export { useMfaSetup };
